import React from 'react'
import { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Collapse, Badge } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';
import ItemView from './ItemView';
import FreshWaterIrrigationItemView from './FreshWaterIrrigationItemView';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FreshWaterIrrigationItemTypeView = ({ handleHideChildrenCheck, hideChildren, toggleChildItemState, handleChildItemToggle, itemList, itemType, itemTypesList, largeEnterpriseDetails, toggleItemTypeState, toggleItemState, handleItemEditPopup,
    handleItemDeletePopup, handleOpenActionPopup, handleItemTypeTogole, handleItemTogole, handleItemHighlight, Section, itemModel }) => {

    const [isOpen, setIsOpen] = useState(itemType.uniqueName == toggleItemTypeState.uniqueName ? toggleItemTypeState.isOpen : false);
    const [isIconUp, setIsIconUp] = useState(itemType.uniqueName == toggleItemTypeState.uniqueName ? toggleItemTypeState.isIconUp : false);

    const toggle = (uniqueName) => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTypeTogole(0, !isOpen, !isIconUp, uniqueName);
    };

    const CustomToastWithLink = () => (
        <div>
            <p>Once you’ve added a fresh water irrigation item you can click on the down arrow to open it and then edit, delete, or add an action. This is the same process as you’ve already encountered earlier.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    if (itemType != undefined) {
        const isLargeEnterprise = largeEnterpriseDetails != null ? largeEnterpriseDetails.isLargeEnterprise : false;
        const selectedLMUId = largeEnterpriseDetails != null ? largeEnterpriseDetails.selectedLMUId : 0;
        let itemListByType = [];
        var LMUList = largeEnterpriseDetails.LMUList;
        if (isLargeEnterprise && selectedLMUId > 0) {
            const selectedLMUList = LMUList.filter(type => type.mapMarkerType == "polygon" && (type.lmuId == selectedLMUId || type.id == selectedLMUId));
            selectedLMUList.map(lmu => {
                let itemListByTypetemp = itemList.filter(item => item.itemTypeName == itemType.name && item.lmuIds.split(',').filter(x => parseInt(x) == lmu.id).length > 0);
                itemListByTypetemp.map(item => {
                    if (itemListByType.filter(x => x.itemId == item.itemId).length == 0) {
                        itemListByType.push(item)
                    }
                })
            })
        }
        else {
            itemListByType = itemList.filter(item => item.itemTypeName == itemType.name);
        }
        const itemCount = itemListByType.filter(x => x.isConnectedToAnotherFreshWaterIrrigationItem == false).length;
        let openActionCount = 0;
        itemListByType.map(item =>
            openActionCount = openActionCount + item.actions.filter(action => action.isCloseout != true).length)

        return (

            itemCount > 0 &&
            <Row>
                <Col>
                    <Card>
                        <CardHeader className="item-header item_click" onClick={(itemTypeId, uniqueName) => toggle(itemType.uniqueName)}>
                            <Row>
                                    {(Section == 'IrrigationRisk' || Section == 'IrrigationMap') && <>
                                        <Col sm="11"><span className="text-capitalize fw-bold color-dark-teal">{itemType.name} </span>{' '}<span className="color-dark-teal-sub"> {itemCount + ' Item(s) '} {!itemModel.isMapOnly && openActionCount > 0 ? ' | ' : ''}
                                            {!itemModel.isMapOnly && <Badge color="primary">
                                                {openActionCount == 0 ? '' : openActionCount}
                                            </Badge>}
                                            {!itemModel.isMapOnly && openActionCount > 0 ? ' Open action(s)' : ''}&nbsp;&nbsp;&nbsp;
                                        <img className="featureIcon" src="/images/info_button_lt.png" onClick={(e) => showToastMessage(e)} /></span></Col>
                                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                </>}
                            </Row>
                        </CardHeader>
                        <Collapse isOpen={isOpen}>
                            <CardBody>
                                {itemListByType.map(item =>
                                    <FreshWaterIrrigationItemView toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle} handleHideChildrenCheck={handleHideChildrenCheck} hideChildren={hideChildren} key={uuid()} item={item} itemTypesList={itemTypesList}
                                        toggleItemState={toggleItemState}
                                        handleItemEditPopup={handleItemEditPopup}
                                        handleItemDeletePopup={handleItemDeletePopup}
                                        handleOpenActionPopup={handleOpenActionPopup}
                                        handleItemTogole={handleItemTogole}
                                        handleItemHighlight={handleItemHighlight}
                                        Section={Section} itemModel={itemModel}
                                    ></FreshWaterIrrigationItemView>
                                )
                                }
                            </CardBody>
                        </Collapse>
                    </Card>
                    <br />
                </Col>
            </Row>
        )

    }
}
export default FreshWaterIrrigationItemTypeView